// src/main.ts
import {
  enableProdMode,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient } from "@angular/common/http";
import { DatePipe } from "@angular/common";

import { IonicRouteStrategy, Platform, provideIonicAngular } from "@ionic/angular/standalone";
import {
  PreloadAllModules,
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from "@angular/router";

import { provideServiceWorker } from "@angular/service-worker";
import { provideAnimations } from "@angular/platform-browser/animations";
import { IonicStorageModule } from "@ionic/storage-angular";

import { Capacitor } from "@capacitor/core";
import { LocationAccuracy } from "@awesome-cordova-plugins/location-accuracy/ngx";

import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { environment } from "./environments/environment";

import { FirebaseApp, initializeApp, provideFirebaseApp } from "@angular/fire/app";
import {
  Auth,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  provideAuth,
} from "@angular/fire/auth";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";
import { getStorage, provideStorage } from "@angular/fire/storage";

// ✅ Native App Check (Capacitor plugin)
import { FirebaseAppCheck } from "@capacitor-firebase/app-check";

// ✅ Web SDK App Check
import { CustomProvider, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

if (environment.production) {
  enableProdMode();
}

function provideStableAuth(): Auth {
  const app = inject(FirebaseApp);

  // Native WebView: explicit init + IndexedDB persistence
  if (Capacitor.isNativePlatform()) {
    return initializeAuth(app, { persistence: indexedDBLocalPersistence });
  }

  // Web / PWA
  return getAuth(app);
}

/**
 * ✅ Initialize App Check early (non-blocking)
 * - Native: Capacitor plugin + CustomProvider bridge (best if you enforce App Check)
 * - Web/PWA: ReCaptcha v3 provider when siteKey exists
 */
function initAppCheck() {
  return async () => {
    try {
      const app = inject(FirebaseApp);
      const platform = inject(Platform);

      // Ensure capacitor bridge ready
      await platform.ready();

      // ----- Native (Android/iOS) -----
      if (Capacitor.isNativePlatform()) {
        // 1) Start native plugin (Play Integrity / App Attest / DeviceCheck)
        await FirebaseAppCheck.initialize({
          debugToken: !environment.production,
          isTokenAutoRefreshEnabled: true,
        });

        // 2) Bridge native token into Web SDK (so AngularFire requests carry App Check)
        initializeAppCheck(app, {
          provider: new CustomProvider({
            getToken: async () => {
              // keep it simple: try cached, then force refresh once
              let r: any = await FirebaseAppCheck.getToken({ forceRefresh: false });
              if (!r?.token) r = await FirebaseAppCheck.getToken({ forceRefresh: true });

              return {
                token: r.token,
                expireTimeMillis: r.expireTimeMillis,
              };
            },
          }),
          isTokenAutoRefreshEnabled: true,
        });

        console.log("[AppCheck] ✅ Native initialized");
        return;
      }

      // ----- Web / PWA -----
      const siteKey = (environment as any).appCheckSiteKey?.trim?.() || "";

      // If no siteKey => App Check disabled on web (simple + avoids extra config)
      if (!siteKey) {
        console.log("[AppCheck] Web: disabled (missing site key)");
        return;
      }

      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });

      console.log("[AppCheck] ✅ Web initialized (reCAPTCHA v3)");
    } catch (e) {
      // non-blocking by design
      console.warn("[AppCheck] init failed (non-blocking):", e);
    }
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),

    provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
    provideHttpClient(),
    provideAnimations(),
    DatePipe,
    LocationAccuracy,

    // Firebase (modular)
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => provideStableAuth()),
    provideFirestore(() => getFirestore(inject(FirebaseApp))),
    provideStorage(() => getStorage(inject(FirebaseApp))),

    // ✅ App Check initializer (runs early)
    provideAppInitializer(initAppCheck()),

    // Ionic Storage
    importProvidersFrom(IonicStorageModule.forRoot()),

    // Service worker (PWA only)
    provideServiceWorker("combined-sw.js", {
      enabled: environment.production && !Capacitor.isNativePlatform(),
      registrationStrategy: "registerImmediately",
    }),
  ],
}).catch(console.error);













// // src/main.ts
// import {
//   enableProdMode,
//   importProvidersFrom,
//   inject,
//   provideAppInitializer,
// } from "@angular/core";
// import { bootstrapApplication } from "@angular/platform-browser";
// import { provideHttpClient } from "@angular/common/http";
// import { DatePipe } from "@angular/common";

// import { IonicRouteStrategy, Platform, provideIonicAngular } from "@ionic/angular/standalone";
// import {
//   PreloadAllModules,
//   RouteReuseStrategy,
//   provideRouter,
//   withComponentInputBinding,
//   withPreloading,
// } from "@angular/router";

// import { provideServiceWorker } from "@angular/service-worker";
// import { provideAnimations } from "@angular/platform-browser/animations";
// import { IonicStorageModule } from "@ionic/storage-angular";

// import { Capacitor } from "@capacitor/core";
// import { LocationAccuracy } from "@awesome-cordova-plugins/location-accuracy/ngx";

// import { AppComponent } from "./app/app.component";
// import { routes } from "./app/app.routes";
// import { environment } from "./environments/environment";

// import { FirebaseApp, initializeApp, provideFirebaseApp } from "@angular/fire/app";
// import {
//   Auth,
//   getAuth,
//   indexedDBLocalPersistence,
//   initializeAuth,
//   provideAuth,
// } from "@angular/fire/auth";
// import { getFirestore, provideFirestore } from "@angular/fire/firestore";
// import { getStorage, provideStorage } from "@angular/fire/storage";

// // ✅ Native App Check (Capacitor plugin)
// import { FirebaseAppCheck } from "@capacitor-firebase/app-check";

// // ✅ Web App Check (Firebase Web SDK)
// import { CustomProvider, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// if (environment.production) {
//   enableProdMode();
// }

// function provideStableAuth(): Auth {
//   const app = inject(FirebaseApp);

//   // Native WebView: explicit init + IndexedDB persistence
//   if (Capacitor.isNativePlatform()) {
//     return initializeAuth(app, { persistence: indexedDBLocalPersistence });
//   }

//   // Web / PWA
//   return getAuth(app);
// }

// /**
//  * ✅ Initialize App Check early
//  * - Native: Capacitor plugin (Play Integrity / DeviceCheck, or debug token in dev)
//  * - Web: ReCaptcha v3 (optional)
//  */
// function initAppCheck() {
//   return async () => {
//     try {
//       const app = inject(FirebaseApp);
//       const platform = inject(Platform);

//       // ✅ ensure native bridge is ready
//       await platform.ready();

//       if (Capacitor.isNativePlatform()) {
//         await FirebaseAppCheck.initialize({
//           debugToken: !environment.production,
//           isTokenAutoRefreshEnabled: true,
//         });

//         // ✅ warm up token on cold start (important)
//         for (let i = 0; i < 8; i++) {
//           try {
//             const r = await FirebaseAppCheck.getToken({ forceRefresh: i === 0 });
//             if (r?.token) break;
//           } catch {}
//           await new Promise((r) => setTimeout(r, 500));
//         }

//         initializeAppCheck(app, {
//           provider: new CustomProvider({
//             getToken: async () => {
//               // try cached first, then force refresh once if empty
//               let r = await FirebaseAppCheck.getToken({ forceRefresh: false });
//               if (!r?.token) r = await FirebaseAppCheck.getToken({ forceRefresh: true });
//               return { token: r.token, expireTimeMillis: r.expireTimeMillis };
//             },
//           }),
//           isTokenAutoRefreshEnabled: true,
//         });

//         console.log("[AppCheck] Native bridge initialized (warmed)");
//         return;
//       }

//       // web fallback (unchanged) ...
//     } catch (e) {
//       console.warn("[AppCheck] init failed (non-blocking):", e);
//     }
//   };
// }

// bootstrapApplication(AppComponent, {
//   providers: [
//     { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
//     provideIonicAngular(),

//     provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
//     provideHttpClient(),
//     provideAnimations(),
//     DatePipe,
//     LocationAccuracy,

//     // Firebase (modular)
//     provideFirebaseApp(() => initializeApp(environment.firebase)),
//     provideAuth(() => provideStableAuth()),
//     provideFirestore(() => getFirestore(inject(FirebaseApp))),
//     provideStorage(() => getStorage(inject(FirebaseApp))),

//     // ✅ App Check initializer (runs early)
//     provideAppInitializer(initAppCheck()),

//     // Ionic Storage
//     importProvidersFrom(IonicStorageModule.forRoot()),

//     // Service worker
//     // main.ts
// provideServiceWorker("combined-sw.js", {
//   enabled: environment.production && !Capacitor.isNativePlatform(),
//   registrationStrategy: "registerImmediately",
// }),

//   ],
// }).catch(console.error);
